<template lang="pug">
.ds-scope
  cliente-header(:mostrar-menu="mostrarMenu")
  .body
    router-view(v-slot="{ Component }")
      suspense
        template(#default)
          component(:is="Component")
        template(#fallback)
          .container: .row: .col: h1 Cargando...
  
    
  a(:href="URLWhatsApp" target="_blank")
    img.wa(src="data:image/png;base64,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", alt='Logo de OpenAI')
 

  site-footer

  // Modal
.modal(
  :id="'modalAxios-' + axiosStore.idModalGlobal"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
  tabindex="-1"
  aria-labelledby="modalAxiosLabel"
  aria-hidden="true"
)
  .modal-dialog.modal-dialog-centered
    .modal-content
      .modal-body.d-flex.justify-content-center.align-items-center
        span.spinner-border.spinner-border-sm.text-primary(role="status" aria-hidden="true")
        |
        span.text-primary.p-2 Cargando...
</template>
<script lang="ts" setup>
import { onMounted, ref, watch } from "vue";
import ClienteHeader from "../components/CCHeader.vue";
import SiteFooter from "../components/MaterialApoyo/layout/SiteFooter.vue";
import initializeGenesys from "@/Aplicaciones/Cliente/Areas/Cliente/helpers/chat.js"
import api from "@/servicios/apiCliente";
import { useStore } from "../store";
import { Cliente } from "@/servicios/api";
const $store = useStore();
import * as utilidades from "@/utilidades";
import useAxiosStore from "@/store/storeAxios";
import * as bootstrap from "bootstrap";

//#region Data
const mostrarMenu = ref(false);
const URLDevQ = ref("https://appointments.clients.debmedia.com/#/company/hircasa/schedules");
const URLWhatsApp = ref("http://wa.me/5215576659885");
const axiosStore = useAxiosStore();
axiosStore.idModalGlobal = utilidades.generarId();
//#endregion

//#region Methods
function abrirModal() {
  const miModal = document.getElementById(`modalAxios-${axiosStore.idModalGlobal}`);
  const modal = bootstrap.Modal.getInstance(miModal);
  if (modal) {
    modal?.show();
  } else {
    const nuevoModal = new bootstrap.Modal(miModal);
    nuevoModal?.show();
  }
}

function cerrarModal() {
  const miModal = document.getElementById(`modalAxios-${axiosStore.idModalGlobal}`);
  const modal = bootstrap.Modal.getInstance(miModal);
  modal?.hide();
}

onMounted( async () =>{
  initializeGenesys()
})

watch(
  () => axiosStore.detectarCambiosRequestResponse,

  x => {
    abrirModal();
    if (axiosStore.contadorRequestResponse <= 0) {
      cerrarModal();
    }
  },

  { deep: true, inmediate: true }
);


function popUpChat() {
  let left = window.innerWidth / 2 - 225;
  window.open(
    "https://chat.hircasa.com/chat/",
    "HIR-Chat",
    "scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no, width=450,height=650,left=" +
      left +
      ",top=80"
  );
}
async function cargarDatos() {
  let usuario: Cliente.Financiamiento.InformacionCliente;
  mostrarMenu.value = false;
  try {
    let resp = await api.Cliente.Cliente.HomeApi.ObtenerInformacion();
    gtag("set", { client_id: resp.data.clienteId });
    mostrarMenu.value = true;
    usuario = resp.data;
    URLDevQ.value = usuario.urlDevQ ?? "";
    URLWhatsApp.value = usuario.urlWhatsApp ?? "";
    $store.clienteId = usuario.clienteId;
    $store.nombrePilaCliente = usuario.nombre ?? "";
    $store.nombrePilaApellidoPaternoCliente = (usuario.nombre ?? "") + " " + (usuario.apellidoPaterno ?? "");
    $store.nombreCompletoCliente = usuario.nombreCompleto ?? "";
    $store.correoCliente = usuario.correo ?? "";
  } catch {} //eslint-disable-line
}
//#endregion

if ($store.sesionIniciada) cargarDatos();
$store.$subscribe((_mutation, state) => {
  if (state.sesionIniciada) cargarDatos();
});
</script>

<style lang="scss">
@import "../components/MaterialApoyo/design-tokens.css";
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

.body {
  /* 78px del header. El footer ya no se descuenta: SiteFooter mide ~693px
     en desktop y más en móvil, así que restarlo dejaba el área vacía. */
  min-height: calc(100vh - 78px);
  background-image: url("../../../assets/bgimage.png");
  background-attachment: fixed;
  background-position: top;
  background-size: cover;
  background-repeat: no-repeat;
}
.wa{
  border-radius: 50%;
  width: 55px;
  height: 55px;
  position: fixed;
  right: 100px;
  bottom: 20px;
}
.dropleft {
  position: fixed;
  top: 50%;
  right: 0;
  border-top-left-radius: 16px;
  border-bottom-left-radius: 16px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  z-index: 1000;
  .contenido {
    width: 0;
    transition: width 0.5s;
  }
  &:hover .contenido {
    width: 402px;
  }
}
</style>
